const organizationsSearchResultsActions = {
  SET_ORGANIZATIONS_INIT_STATE: 'SET_ORGANIZATIONS_INIT_STATE',
  GET_ORGANIZATIONS: 'GET_ORGANIZATIONS'
};
export default organizationsSearchResultsActions;
